<template>
  <div>
    <div class="question__item">
      <BaseContent :info="params"></BaseContent>
      <el-form class="question__form">
        <el-form-item class="question__form--item">
          <el-radio-group v-model="form.q_option_id">
            <template v-for="item in params.option">
              <div :key="item.o_id" class="group__item">
                <el-radio
                  :label="item.o_id"
                  @change="radioChange(item.o_id, item)"
                  :disabled="
                    item.o_is_disabled ||
                      (optionDisable && item.o_is_required === '0')
                  "
                >
                  <div>
                    <div class="ui_label">{{ item.o_name }}</div>
                    <div class="ui_text" v-show="item.o_has_input === 1">
                      <span class="req" v-show="item.o_is_required === '1'"
                        >*</span
                      >
                      <el-input
                        v-model="form.inputsValue[item.o_id]"
                        @focus="focusSelect(item.o_id, item)"
                        @blur="radioChange(item.o_id, item)"
                        @change="changeInput(item.o_id)"
                        :disabled="
                          item.o_is_disabled ||
                            (optionDisable && item.o_is_required === '0')
                        "
                      ></el-input>
                    </div>
                  </div>
                </el-radio>
              </div>
            </template>
          </el-radio-group>
        </el-form-item>
        <ErrMessage v-show="errShow" :visible="errShow" :title="errTitle">
        </ErrMessage>
      </el-form>
    </div>
    <check-item
      :check="params.check"
      :form="form"
      @upCheck="upCheck"
      v-on="$listeners"
      v-bind="$attrs"
    ></check-item>
  </div>
</template>
<script>
import ErrMessage from '../../components/errorMessage'
import BaseContent from './baseContent'
import { BASE_TYPE_CHECK_DATA_FUN } from '../constant/index'
import * as CHECK_DATA_FUN from '../constant/method'
import { mixin } from '../constant/mixin'
import CheckItem from './checkItem'
export default {
  name: 'radioSelect',
  props: {
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mixins: [mixin],
  data () {
    return {
      form: {
        q_option_id: 0,
        inputsValue: {},
        q_category: 0,
        question_id: 0,
        q_answer_info: '',
        q_remark: '',
        q_is_required: 0,
        o_is_required: '0',
        o_has_input: 0,
        o_is_conflict: 0,
        data_datetime: '',
        is_kaocha: '',
        remark: '',
        q_group_id: '',
        q_number: ''
      },
      info: {},
      saveData: {},
      errShow: false,
      errTitle: '',
      selectOption: {},
      optionDisable: false, // 判断是否有is_reqiure的比选项
      inputIsChange: false, // 是否则改变input的值只做校验不请求逻辑接口
      required_option_id: '',
      or_relation: ''
    }
  },
  computed: {
    checkFun () {
      return CHECK_DATA_FUN[BASE_TYPE_CHECK_DATA_FUN[this.form.q_category]]
    }
  },
  components: {
    ErrMessage,
    BaseContent,
    CheckItem
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('pick', val)
      },
      deep: true
    }
  },
  methods: {
    checkData (isSubmit) {
      let checkResult = this.checkFun(this.form, this.params)
      if (checkResult.noData) {
        this.errShow = true
        this.errTitle = checkResult.errTitle
      } else {
        this.errShow = false
        if (!this.inputIsChange) {
          !isSubmit && this.logicalHandler()
        }
      }
    },
    changeInput (id) {
      this.inputIsChange = true
      this.saveData[id] = this.form.inputsValue[id]
      this.checkData()
    },
    focusSelect (id, option) {
      this.inputIsChange = true
      this.form.q_option_id = id
      if (Object.keys(this.form.inputsValue).length) {
        Object.keys(this.form.inputsValue).forEach(item => {
          this.form.inputsValue[item] = ''
        })
        if (this.saveData[id]) {
          this.form.inputsValue[id] = this.saveData[id]
        }
      }
      this.setFormOtherData(option)
      this.checkData()
    },
    radioChange (id, option) {
      this.inputIsChange = false
      this.form.q_option_id = id
      if (Object.keys(this.form.inputsValue).length) {
        Object.keys(this.form.inputsValue).forEach(item => {
          this.form.inputsValue[item] = ''
        })
        if (this.saveData[id]) {
          this.form.inputsValue[id] = this.saveData[id]
        }
      }
      this.setFormOtherData(option)
      this.checkData()
    },
    setFormOtherData (option) {
      const key = ['o_is_required', 'o_has_input', 'o_is_conflict']
      key.forEach(item => {
        this.form[item] = option[item]
      })
    },
    upCheck (val) {
      this.form = Object.assign(this.form, val)
    }
  },
  mounted () {
    // this.info = { ...this.info, ...this.params }
    Object.keys(this.form).map(item => {
      if (item !== 'inputsValue') {
        this.form[item] = this.params[item] || ''
      }
      if (item === 'data_datetime') {
        this.form[item] =
          this.params.check[0] && this.params.check[0].data_datetime
      }
      if (item === 'remark') {
        this.form[item] = this.params.check[0] && this.params.check[0].remark
      }
    })
    if (!this.params.option) return
    let default_id, reqiure_id, defalut_reqiure_id, default_disabled_id
    this.params.option.forEach(o_item => {
      const {
        o_default_selected,
        o_id,
        q_remark,
        o_has_input,
        o_is_required,
        o_is_disabled
      } = o_item
      if (o_default_selected === 1) {
        default_id = o_id
        if (o_is_disabled === false) {
          default_disabled_id = o_id
        }
      }
      if (o_is_required === '1') {
        this.required_option_id = o_id
        reqiure_id = o_id
        this.optionDisable = true
      }
      if (o_is_required === '1' && o_default_selected === 1) {
        defalut_reqiure_id = o_id
      }
      if (o_has_input === 1 && q_remark) {
        this.$set(this.form.inputsValue, o_id, q_remark)
        this.$set(this.saveData, o_id, q_remark)
      }
    })

    this.form.q_option_id = defalut_reqiure_id || reqiure_id || default_disabled_id || default_id || ''
    // if (this.params.relation === 'and') {
    //   this.form.q_option_id = this.required_option_id ? this.required_option_id : this.form.q_option_id
    // } else {
    //   this.form.q_option_id = this.or_relation
    // }
  }
}
</script>
<style lang="scss">
.group__item {
  margin: 10px;
  .ui_text {
    display: inline-block;
    padding-left: 15px;
    width: 400px;
  }
}
.el-radio__label {
  display: inline-flex;
}
.ui_label {
  white-space: normal;
  display: inline;
}
</style>
